import { Dropdown, ErrorContainer, LabelComponent } from 'components';
import { useFormikContext } from 'formik';
import { useEffect } from 'react';
import { getBillingProviders } from 'store/clients/clientsActions';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { getLsUserRoleObject } from 'modules/networkTools/localStorageTokens';

const Provider = ({ disabled }: { disabled: boolean }) => {
  const dispatch = useAppDispatch();
  const { organizationId } = getLsUserRoleObject();
  const formik = useFormikContext<{
    billingProviderId: string;
  }>();
  const providers = useAppSelector((state) => state.clients.billingProviders.data);

  const filteredProviders = providers.filter((p) => p.id !== -1);

  useEffect(() => {
    dispatch(getBillingProviders({ organizationId }));
  }, []);

  return (
    <>
      <LabelComponent text="Provider" />
      <Dropdown
        data={filteredProviders}
        label="Select"
        name="billingProviderId"
        value={formik.values.billingProviderId}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        disabled={disabled}
        withGradient
      />
      <ErrorContainer
        errors={formik.errors}
        visible={formik.touched.billingProviderId && formik.errors.billingProviderId}
        name="billingProviderId"
      />
    </>
  );
};

export default Provider;
